"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Board = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _resource = require("../../reducers/resource.js");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _AddFlowForm = _interopRequireDefault(require("./AddFlowForm"));
var _FlowList = _interopRequireDefault(require("./FlowList.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Board = exports.Board = /*#__PURE__*/function (_React$Component) {
  _inherits(Board, _React$Component);
  function Board() {
    var _this;
    _classCallCheck(this, Board);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Board, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_addFlow", function (values) {
      return _this.props.addFlow(values).then(function (data) {
        _this.props.history.push("/flow/admin/".concat(data.id));
      });
    });
    return _this;
  }
  _createClass(Board, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.loadList();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: this.props.loading
      }, /*#__PURE__*/_react["default"].createElement("h2", null, "Flow list"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3"
      }, /*#__PURE__*/_react["default"].createElement(_AddFlowForm["default"], {
        addFlow: this._addFlow
      })), /*#__PURE__*/_react["default"].createElement(_FlowList["default"], {
        data: this.props.data,
        deleteFlow: this.props.deleteFlow,
        editFlow: this.props.editFlow
      }));
    }
  }]);
  return Board;
}(_react["default"].Component);
_defineProperty(Board, "propTypes", {
  addFlow: _propTypes["default"].func,
  editFlow: _propTypes["default"].func,
  deleteFlow: _propTypes["default"].func,
  loadList: _propTypes["default"].func,
  data: _propTypes["default"].array,
  loading: _propTypes["default"].bool,
  history: _propTypes["default"].object
});
var mapStateToProps = function mapStateToProps(state) {
  return {
    data: state.flow.resource.list,
    loading: state.flow.resource.loading
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  addFlow: _resource.addFlow,
  editFlow: _resource.editFlow,
  deleteFlow: _resource.deleteFlow,
  loadList: _resource.loadList
})(Board);